<div class="chart-container">
    <div class="flex position-relative">
        <app-report-filters
            [hiddenFilters]="reportHiddenItems"
            [dataSource]="dataSource"
            [selectedDateFilter]="selectedDateFilter"
            (onDateChange)="applyPresetDateFilter($event)"
        ></app-report-filters>
        <div class="actions">
            <button [matMenuTriggerFor]="gridActions" mat-icon-button>
                <mat-icon
                    aria-hidden="true"
                    class="mat-icon material-icons"
                    role="img"
                    >settings</mat-icon
                >
            </button>
            <mat-menu
                #gridActions="matMenu"
                class="switch-nested-menu-left-arrows"
                xPosition="before"
            >
                <button (click)="exportCsv()" mat-menu-item>Export</button>
                <button (click)="openSettings()" mat-menu-item>Settings</button>
            </mat-menu>
        </div>
    </div>

    <div 
        class="table-container mat-elevation-z3" 
        (scroll)="onTableScroll($event)"
        role="region"
        aria-label="Customer capture rate data table"
    >
        <mat-table 
            [dataSource]="dataSource" 
            matSort 
            class="full-width-table"
            role="table"
        >
            <!-- Company Column -->
            <ng-container matColumnDef="company">
                <th *matHeaderCellDef mat-header-cell class="header-cell">
                    <span *ngIf="dataSource">
                        <app-table-column-filter
                            [matDataSource]="dataSource"
                            [matSort]="sort"
                            columnId="company"
                            propertyName="company"
                        >
                            <span>Company</span>
                        </app-table-column-filter>
                    </span>
                </th>
                <td *matCellDef="let info" mat-cell>
                    <a *ngIf="info.oid > 0" (click)="goToCustomerDetails(info)" class="btn-link">{{ info.company || '—' }}</a>
                    <span *ngIf="!info.oid || info.oid <= 0">{{ info.company || '—' }}</span>
                </td>
            </ng-container>

            <!-- Dynamic FBO Columns: Airport Orders and FBO Orders -->
            <ng-container *ngFor="let fboCol of fboColumns; trackBy: trackByFboId">
                <ng-container [matColumnDef]="fboCol.airportOrdersColumnId">
                    <th *matHeaderCellDef mat-header-cell>
                        <span *ngIf="dataSource">
                            <app-table-column-filter
                                [matDataSource]="dataSource"
                                [matSort]="sort"
                                [columnId]="fboCol.airportOrdersColumnId"
                                [propertyName]="fboCol.airportOrdersColumnId"
                            >
                                <span>Total Orders at {{ fboCol.icao }}</span>
                            </app-table-column-filter>
                        </span>
                    </th>
                    <td *matCellDef="let info" mat-cell>
                        {{ getAirportOrders(info, fboCol.fboId) || 0 }}
                    </td>
                </ng-container>

                <!-- FBO Orders Column -->
                <ng-container [matColumnDef]="fboCol.fboOrdersColumnId">
                    <th *matHeaderCellDef mat-header-cell>
                        <span *ngIf="dataSource">
                            <app-table-column-filter
                                [matDataSource]="dataSource"
                                [matSort]="sort"
                                [columnId]="fboCol.fboOrdersColumnId"
                                [propertyName]="fboCol.fboOrdersColumnId"
                            >
                                <span>{{ fboCol.fboName }} {{ fboCol.icao }}</span>
                            </app-table-column-filter>
                        </span>
                    </th>
                    <td *matCellDef="let info" mat-cell>
                        {{ getFboOrders(info, fboCol.fboId) || 0 }}
                    </td>
                </ng-container>
            </ng-container>

            <!-- Total Network Capture Rate Column -->
            <ng-container matColumnDef="totalNetworkCaptureRate">
                <th *matHeaderCellDef mat-header-cell class="header-cell">
                    <span *ngIf="dataSource">
                        <app-table-column-filter
                            [matDataSource]="dataSource"
                            [matSort]="sort"
                            columnId="totalNetworkCaptureRate"
                            propertyName="totalNetworkCaptureRate"
                        >
                            <span>Total Network Capture Rate</span>
                        </app-table-column-filter>
                    </span>
                </th>
                <td *matCellDef="let info" mat-cell>
                    {{ getTotalNetworkCaptureRate(info) }}
                </td>
            </ng-container>

            <!-- Network Capture Rate Column -->
            <ng-container matColumnDef="networkCaptureRate">
                <th *matHeaderCellDef mat-header-cell class="header-cell">
                    <span *ngIf="dataSource">
                        <app-table-column-filter
                            [matDataSource]="dataSource"
                            [matSort]="sort"
                            columnId="networkCaptureRate"
                            propertyName="networkCaptureRate"
                        >
                            <span>Network Capture Rate</span>
                        </app-table-column-filter>
                    </span>
                </th>
                <td *matCellDef="let info" mat-cell>
                    {{ info.networkCaptureRate || 0 }}%
                </td>
            </ng-container>

            <!-- Single Header Row -->
            <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
            
            <!-- Data Rows -->
            <tr *matRowDef="let row; columns: visibleColumns" mat-row></tr>
        </mat-table>
    </div>
</div>
<ngx-ui-loader
    [loaderId]="chartName"
    bgsColor="rgb(100, 181, 246)"
    bgsPosition="center-center"
    bgsType="ball-spin"
    overlayColor="rgba(0, 0, 0, 0.1)"
></ngx-ui-loader>
<div class="invisible">
    <mat-paginator
        (page)="(0); onPageChanged($event)"
        [length]="dataSource.data?.length"
        [pageSizeOptions]="[10, 25, 50, 100]"
        [pageSize]="pageSize"
    >    </mat-paginator>
</div>

